import React from 'react';
import Table from 'react-bootstrap/Table';
import { ICronJob } from '../../models/ICronJob';
import CronJobsListItem from './CronJobsListItem';

type CronJobsListProps = {
    cronJobs: ICronJob[];
    onCronJobEdit: (cronJob: ICronJob) => void;
    onCronJobDelete: (cronJob: ICronJob) => void;
}

const CronJobsList: React.FC<CronJobsListProps> = ({ cronJobs, onCronJobEdit, onCronJobDelete }) => {
    return (
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th>Title</th>
                    <th>Alias</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>Updated</th>
                    <th>#</th>
                </tr>
            </thead>
            <tbody>
                {cronJobs.map(cronJob => (
                    <CronJobsListItem
                        key={cronJob.id}
                        cronJob={cronJob}
                        onCronJobEdit={onCronJobEdit}
                        onCronJobDelete={onCronJobDelete}
                    />
                ))}
            </tbody>
        </Table>
    );
};

export default CronJobsList;
